__turbopack_context__.v({
  "bubbleNavigationWrapper": "bED5aq_bubbleNavigationWrapper",
  "description": "bED5aq_description",
  "headerContent": "bED5aq_headerContent",
  "headerContentContainer": "bED5aq_headerContentContainer",
  "headerWrapper": "bED5aq_headerWrapper",
  "image": "bED5aq_image",
  "popularBrandsWrapper": "bED5aq_popularBrandsWrapper",
  "retakeQuizButton": "bED5aq_retakeQuizButton",
});
